let smsPrefixed = name => 'samplemanagement/common/' + name
let prefixed = name => 'common/' + name

export const searchCriteria = smsPrefixed('searchCriteria')
export const commonSearchCriteria = prefixed('searchCriteria')

export const age = smsPrefixed('age')
export const brandCodes = smsPrefixed('brandCodes')
export const categoryCodes = smsPrefixed('categoryCodes')
export const classCodes = smsPrefixed('classCodes')
export const cocCatalogs = smsPrefixed('cocCatalogs')
export const cocFabric = smsPrefixed('cocFabric')
export const cocSubCategory = smsPrefixed('cocSubCategory')
export const coos = smsPrefixed('coos')
export const deactivatedAdSampleTypes = smsPrefixed('deactivatedAdSampleTypes')
export const deactivatedPurposes = smsPrefixed('deactivatedPurposes')
export const departmentCodes = smsPrefixed('departmentCodes')
export const devSearchParamsCache = smsPrefixed('devSearchParamsCache')
export const distros = smsPrefixed('distros')
export const divisionCodes = smsPrefixed('divisionCodes')
export const end = smsPrefixed('end')
export const flowLongDescriptions = smsPrefixed('flowLongDescriptions')
export const flowNames = smsPrefixed('flowNames')
export const orderingTimelinesss = smsPrefixed('orderingTimelinesss')
export const gauge = smsPrefixed('gauge')
export const gender = smsPrefixed('gender')
export const gisAgentCodes = smsPrefixed('gisAgentCodes')
export const gisAgents = smsPrefixed('gisAgents')
export const inStoreDates = smsPrefixed('inStoreDates')
export const itemTypes = smsPrefixed('itemTypes')
export const keyCostDriver = smsPrefixed('keyCostDriver')
export const linePlans = smsPrefixed('linePlans')
export const marketCodes = smsPrefixed('marketCodes')
export const materialAction = smsPrefixed('materialAction')
export const planningPeriods = smsPrefixed('planningPeriods')
export const planningYears = smsPrefixed('planningYears')
export const plmSampleTypes = smsPrefixed('plmSampleTypes')
export const productTeam = smsPrefixed('productTeam')
export const productTypes = smsPrefixed('productTypes')
export const purposes = smsPrefixed('purposes')
export const rawMaterialType = smsPrefixed('rawMaterialType')
export const requestPurpose = smsPrefixed('requestPurpose')
export const roundNum = smsPrefixed('roundNum')
export const sampleMarkets = smsPrefixed('sampleMarkets')
export const seasonalWorkspace = smsPrefixed('seasonalWorkspace')
export const shipToAttns = smsPrefixed('shipToAttns')
export const sizeModels = smsPrefixed('sizeModels')
export const smrSearchParamsCache = smsPrefixed('smrSearchParamsCache')
export const smrStatus = smsPrefixed('smrStatus')
export const ssns = smsPrefixed('ssns')
export const subCategoryCodes = smsPrefixed('subCategoryCodes')
export const subClassCodes = smsPrefixed('subClassCodes')
export const svdOffice = smsPrefixed('svdOffice')
export const smrLateReasons = smsPrefixed('smrLateReasons')
export const smrOrderingTimeliness = smsPrefixed('smrOrderingTimeliness')
export const smrYardageTimeliness = smsPrefixed('smrYardageTimeliness')
export const IS_SMS_VENDOR = smsPrefixed('IS_SMS_VENDOR')



// WEBPACK FOOTER //
// ./src/components/samplemanagement/common/store/definition.js